import React from 'react'
import styles from './SeoHomepage.scss'

const SeoHomepage = ({ seoFooter }) => (
  <div className={`container ${styles['homepage-seo-footer']}`}>
    <small data-test='homepage-seo-text' dangerouslySetInnerHTML={{ __html: seoFooter }} />
  </div>
)

export default SeoHomepage
